export default __webpack_public_path__ + "static/media/logo-temporary.231e8e08.png";